<template>
    <div>
        <a-row>
            <a-card>
                <a-table
                        :columns="columns"
                        :pagination="false"
                        :rowKey="record => record.supplierId"
                        :data-source="packList" >
                    <template slot="supplierName" slot-scope="record">
                        {{record.supplierName}}
                    </template>
                    <template slot="state" slot-scope="record" >
                        <a-radio-group v-model="record.state"  @change="change()">
                            <a-radio :value="1">参与</a-radio>
                            <a-radio :value="0">不参与</a-radio>
                        </a-radio-group>
                    </template>

                    <template slot="sort"  slot-scope="record">
                        <span v-if="record.state === 1">
                            {{record.sort}}
                        </span>
                    </template>

                </a-table>
            </a-card>
                        <div class="mt-5 mb-5 " style="text-align: center;">
                            <a-button type="primary"  :loading="loading" @click="general" >随机排序</a-button>
                            <span>&nbsp;</span>
                            <writer :referId="projectId" attach-key="SUPPLIER_SHOW" writer-key="SUPPLIER_SHOW">演示与述标顺序确认表</writer>
                            <!-- <span>&nbsp;</span>
                            <writer :referId="projectId" attach-key="demoNarrationMark" writer-key="demoNarrationMark">不参加演示与述标登记表
                            </writer> -->
                            <span>&nbsp;</span>
                            <a-button   type="danger" @click="onClose" >
                                关闭
                            </a-button>
                        </div>

        </a-row>
    </div>

</template>

<script>

  import qs from 'qs'
  import moment from 'moment'
  import Writer from '@/views/bid/wrtiter/Writer'

  export default {
    props: {
      packId: {
        type: String,
        required: true
      },
      projectId: {
        type: String,
        required: true
      },
      random: {
        type: String,
        default: '',
        required: false
      }
    },
    components: {
      moment,
      Writer
    },
    created() {
      this.initPacks()//加载包件基本信息
    },
    watch: {
      random: {
        immediate: false,
        handler (newValue, oldValue) {
          console.log(newValue)
          if (newValue !== oldValue) {
            this.initPacks()
          }
        }
      }
    },
    beforeDestroy() {
    },
    data() {
      return {
        small: 'small',
        data: [],
        packList: [],
        loading: false,
        columns: [
          {
            title: '供应商名称',
            align: 'left',
            scopedSlots: {customRender: 'supplierName'}
          },
          {
            title: '是否参与演示',
            align: 'center',
            scopedSlots: {customRender: 'state'}
          },
          {
            title: '演示/述标顺序号',
            align: 'center',
            scopedSlots: {customRender: 'sort'}
          },
        ],
      }
    },
    methods: {
      initPacks() {
        let that = this
        that.packList = []
        this.$http.get("/api/1/bidShow/getBidShow/" + this.packId).then(function (res) {
          if (res.code == 200) {
            that.packList = res.result
          }
        });
      },
      change() {

      },
      general() {
        var dataModel = {
          dataList: this.packList,
          xmid:this.projectId
        }
        let that = this
        that.loading = true
        that.$http.post('/api/1/bidShow/updateBidShowList',  qs.stringify(dataModel,{allowDots: true})).then(function (res) {
          if (res.code == 200) {
            that.loading = false
            that.$message.info("操作成功")
            that.initPacks()
          }
        });

      },
      sysWarning(content) {
        let secondsToGo = 2;
        const modal = this.$warning({
          title: '温馨提示',
          content: content,
          footer: ''
        });
        const interval = setInterval(() => {
          secondsToGo -= 1;
          modal.update({
            content: content,
          });
        }, 1000);
        setTimeout(() => {
          clearInterval(interval);
          modal.destroy();
        }, secondsToGo * 1000);
      },
      sysError(content) {
        let secondsToGo = 3;
        const modal = this.$error({
          title: '温馨提示',
          content: content,
        });
      },
      onClose() {
        // this.visible = true
        this.$confirm({
          title: '提示',
          content: '你确定要关闭当前窗口吗？',
          onOk() {
            window.close();
          },
          onCancel() {},
        });
      },
      getUrlValue() {
        return '/api/1/bidShow/hasData/'+this.projectId
      }
    },
  }
</script>

<style scoped>
    .t1 {
        background: #f9f9f9;
        border: 1px solid #e6e6e6;
        padding: 6px 12px;
        position: relative;
    }

    .t1 table {
        table-layout: fixed;
    }

    .t1 th {
        text-align: justify;
        text-align-last: justify;
        color: #8c8c8c;
        font-weight: 500;
    }

    .t1 td {
        color: #262626;
        font-weight: bold;
        padding: 6px 50px 6px 0;
    }

    .t1 .btn {
        position: absolute;
        right: 20px;
        margin: auto;
        top: 0;
        bottom: 0;
    }

    .t2 {
        display: flex;
        justify-content: space-between;
        border-bottom: 4px solid #f7f7f7;
        padding: 8px 0;
    }

    .t3 {
        width: 100%;
    }

    .t3 td {
        font-weight: 500;
        border-bottom: 1px solid #e6e6e6;
        padding: 12px 0;
        text-align: center;
    }

    .t3 thead td {
        color: #8c8c8c;
    }

    .t3 tbody tr:nth-child(1) td {
        background: #FFF5EF;
    }

    .t3 td:nth-child(1) {
        text-align: left;
    }

    .t3 td:nth-last-child(1) {
        text-align: right;
    }

    .t4 {
        width: 200px;
        height: 60px;
        text-align: center;
    }

    /deep/ .t4 .ant-input-number-input {
        font-size: 30px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #ff0000;
    }

    .scrollbar-zdy{
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 160px;
        margin-right: -4px;
    }
    /*-------滚动条整体样式----*/
    .scrollbar-zdy::-webkit-scrollbar {
        width:4px;
    }
    /*滚动条里面小方块样式*/
    .scrollbar-zdy::-webkit-scrollbar-thumb {
        border-radius:100px;
        background:rgba(0,0,0,0.2);
    }
    /*滚动条里面轨道样式*/
    .scrollbar-zdy::-webkit-scrollbar-track {
        border-radius:0;
        background:rgba(0,0,0,0.1);
    }
    /deep/ .d-flex .ant-progress-inner{
        border-radius: 0;
        overflow: inherit;
    }
    /deep/ .d-flex .ant-progress-bg{
        border-radius: 0 !important;
    }

    /deep/ .d-flex .w-100.arrow .ant-progress-bg::before{
        content: "";
        border-top: 10px solid rgba(0, 0, 0, 0);
        border-right: 10px solid rgba(0, 0, 0, 0);
        border-bottom: 10px solid #509eff;
        border-left: 10px solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -10px;
        top: 10px;
    }
    /deep/ .d-flex .flex-grow-shrink.arrow .ant-progress-bg::before{
        content: "";
        border-top: 10px solid rgba(0, 0, 0, 0);
        border-right: 10px solid rgba(0, 0, 0, 0);
        border-bottom: 10px solid #ff5454;
        border-left: 10px solid rgba(0, 0, 0, 0);
        position: absolute;
        right: -10px;
        top: 10px;
    }

    /deep/ .d-flex .w-100 .ant-progress-inner{
        background: #509eff;
    }
    /deep/ .d-flex .flex-grow-shrink .ant-progress-inner{
        background: #ff5454;
    }
    /deep/ .ant-table table {
        width: 100%;
        text-align: left;
        border-radius: 4px 4px 0 0;
        border-collapse: separate;
        border-spacing: 0;
        font-size: 20px;
        font-weight: bold;
    }
</style>
